<ion-header class="ion-no-border page">

  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-back-button defaultHref="/dashboard"></ion-back-button>
    </ion-buttons>
    <ion-title mode="ios">
      <div  (click)="goHome()" class="header-logo">&nbsp;</div>
    </ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="showMenu()" class="menu" [attr.aria-label]="'ARIA.MENU.BUTTON.LABEL_0' | translate">
        <ion-icon slot="icon-only" aria-hidden="true"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>

  <div class="page-title" translate>CONTENT.PURCHASE.TITLE</div>

</ion-header>

<ion-content class="ion-padding page2" no-bounce>
  <ion-list>
    <ion-item>
      <ion-grid>
        <ion-row>
          <ion-col size="12">
            <ion-label class="ion-text-wrap content-title">
              {{getLocalizedContentText(userContent.contentFull.title)}}
            </ion-label>
          </ion-col>
        </ion-row>
        <ion-row>
          <ion-col size="12">
            <rich-text class="description" [text]="getLocalizedContentText(userContent.contentFull.description)">
            </rich-text>
          </ion-col>
        </ion-row>
        <ion-row>
          <ion-col size="12">
            <div class="store-head" translate>CONTENT.PRODUCT.DESCRIPTION
            </div>
          </ion-col>
        </ion-row>
        <ion-row>
          <ion-col size="12">
            <div class="store-title">{{product.title}}
            </div>
          </ion-col>
        </ion-row>
        <ion-row>
          <ion-col size="12">
            <div class="store-description">{{product.description}}
            </div>
          </ion-col>
        </ion-row>
        <ion-row class="action" *ngIf="userContent.state == 3">
          <ion-col size="12">
            <ion-label class="info ion-text-wrap" translate [translateParams]="{weeks: userContent.contentFull.weeks}">
              {{userContent.contentFull.weeks > 1 ? 'CONTENT.DURATION_WEEKS' : 'CONTENT.DURATION_WEEK'}}
            </ion-label>
          </ion-col>
        </ion-row>
        <ion-row class="action" *ngIf="userContent.state == 3">
          <ion-col size="12" class="button-field">
            <ion-button fill="solid" shape="round" expand="block" color="light" class="full-width" translate [translateParams]="{price: getPrice(userContent)}" (click)="purchase()">
              CONTENT.BUTTON.PURCHASENOW
            </ion-button>
          </ion-col>
        </ion-row>
      </ion-grid>
     </ion-item>
  </ion-list>
</ion-content>
